module.exports = "/static/assets/b426caa86e283eeef95134cede917635.png";